// extracted by mini-css-extract-plugin
export var menuIcon = "_ta-0";
export var menuIconInline = "_ta-1";